export default __webpack_public_path__ + "static/media/Pcv1AssemblyH3.a7a82afb.png";